import React from 'react';

import { bemBlock } from '../../../modules/bem';
import { InputSelect } from '../../input-select/InputSelect';
import { LayoutRow } from '../../layout-row/LayoutRow';

import './ActionsMenuSubMenuSelectItem.less';

const block = bemBlock('n-actions-menu-sub-menu-select-item');

type SelectButtonProps = Pick<
  React.ComponentProps<typeof InputSelect.Button>,
  'placeholder' | 'variant'
>;

type ActionsMenuSubMenuSelectItemProps = React.ComponentProps<'button'> &
  SelectButtonProps & { label?: React.ReactNode };

export const ActionsMenuSubMenuSelectItem = React.forwardRef<
  React.ElementRef<'button'>,
  ActionsMenuSubMenuSelectItemProps
>(function ActionsMenuSubMenuSelectItem(
  { className, children, onPointerMove, onPointerLeave, placeholder, variant, label, ...props },
  ref,
) {
  return (
    <LayoutRow
      span="12"
      alignItems="center"
      spacedChildren="sm"
      justifyContent="space-between"
      className={block()}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
      }}
    >
      {label}
      <InputSelect.Button
        className={block({ element: 'select', extra: className })}
        placeholder={placeholder}
        variant={variant}
        {...props}
        ref={ref}
      >
        {children}
      </InputSelect.Button>
    </LayoutRow>
  );
});
